import { Dispatch } from 'redux';
import { typedAction } from 'store/modules/base';
import { Moment } from 'moment';
import {
  DELETEInvestidor,
  DELETEUploadDoc as DELETEUploadDocInvestidor,
  GETBloqueio,
  GETBloqueioDocumentDownloadLink,
  GETBloqueios,
  GETConciliacoesPaginated,
  GETConciliacoesContasDeposito,
  GETDocumentDownloadUrl as GETInvestidorDocumentDownloadUrl,
  GETInvestidor,
  GETInvestidores,
  GETInvestidorByCpfCnpj,
  GETPosicoes,
  POSTBloqueio,
  POSTBloqueiosEmLote,
  GETConciliacaoContaDepositoDownload,
  POSTConfirmarConciliacaoContaDeposito,
  POSTConfirmarConciliacaoContaDepositoEmLote,
  POSTInvestidor,
  POSTFundoInvestidor,
  POSTLiberarBloqueio,
  POSTLiberarSuspensaoInvestidor,
  POSTSuspenderInvestidor,
  POSTBloqueiosPaginated,
  PUTInvestidor,
  PUTUploadBloqueioDocs,
  PUTUploadDoc as PUTUploadDocInvestidor,
  POSTInvestidorPaginated,
  POSTExtratos,
  POSTCertidaoGravame,
  GETInvestidorInstrumentos,
  POSTCertidaoTitularidade,
  POSTCertidaoInadimplencia,
  GETInvestidoresEscriturador,
  GETFundoInvestidorByInvestidorId,
  PUTFundoInvestidor
} from 'requests/investidor';
import {
  InvestidorResponse,
  CadastroInvestidorRequest,
  InvestidorDocumentResponse,
  GETInvestidoresParams,
  GETConciliacoesContasDepositoResponse,
  GETInvestidorPosicoesRequest,
  PosicaoResponse,
  BloqueioResponse,
  BloqueioRequest,
  AdicionarBloqueioEmLoteRequest,
  ResponseBloqueioEmLote,
  BloqueioDocumentType,
  ConciliacaoContaDepositoResponse,
  FundoInvestidorRequest,
  InvestidorFundoResponse,
  GETInvestidoresFilterParams,
  GETBloqueiosFilterParams,
  PaginatedResult,
  AdicionarExtratoRequest,
  ExtratoResponse,
  GETConciliacaoCDFilterParams,
  GetInvestidorInstrumentosParams,
  InvestidorInstrumentoFinanceiroResponse,
  CertidaoTitularidadeRequest,
  CertidaoInadimplenciaParams,
  InvestidorResumo,
} from 'common/genericTypes';
import { GUID } from 'aws-sdk/clients/es';

export interface InvestidorApiState {
  getInvestidor(
    dispatch: Dispatch,
    investidorId: string,
    stackRequest?: boolean
  ): Promise<InvestidorResponse>;
  postInvestidor(
    dispatch: Dispatch,
    cadastroInvestidor: CadastroInvestidorRequest,
    stackRequest?: boolean
  ): Promise<InvestidorResponse>;
  postFundoInvestidor(
    dispatch: Dispatch,
    fundoInvestidorRequest: FundoInvestidorRequest,
    stackRequest?: boolean
  ): Promise<InvestidorFundoResponse>;
  putInvestidor(
    dispatch: Dispatch,
    investidorId: string,
    cadastroInvestidor: CadastroInvestidorRequest,
    stackRequest?: boolean
  ): Promise<InvestidorResponse>;
  getDocumentDownloadUrl(
    dispatch: Dispatch,
    investidorId: string,
    documentId: string,
    stackRequest?: boolean
  ): Promise<string>;
  putUploadDoc(
    dispatch: Dispatch,
    investidorId: string,
    investidorDocumentType: string,
    file: File,
    stackRequest?: boolean
  ): Promise<InvestidorDocumentResponse>;
  getInvestidores(
    dispatch: Dispatch,
    params?: GETInvestidoresParams,
    stackRequest?: boolean
  ): Promise<Array<InvestidorResponse>>;
  getInvestidorByCpfCnpj(
    dispatch: Dispatch,
    cpfCnpj: string,
    participanteId: GUID,
    stackRequest?: boolean
  ): Promise<InvestidorResponse>;
  postInvestidorPaginated(
    dispatch: Dispatch,
    params?: GETInvestidoresFilterParams,
    stackRequest?: boolean
  ): Promise<PaginatedResult<InvestidorResponse>>;
  postBloqueiosPaginated(
    dispatch: Dispatch,
    params?: GETBloqueiosFilterParams,
    stackRequest?: boolean
  ): Promise<PaginatedResult<BloqueioResponse>>;
  deleteInvestidor(
    dispatch: Dispatch,
    investidorId?: string,
    stackRequest?: boolean
  ): Promise<Array<InvestidorResponse>>;
  postSuspenderInvestidor(
    dispatch: Dispatch,
    investidorId: string,
    stackRequest?: boolean
  ): Promise<InvestidorResponse>;
  postLiberarSuspensaoInvestidor(
    dispatch: Dispatch,
    investidorId: string,
    stackRequest?: boolean
  ): Promise<InvestidorResponse>;
  getConciliacaoContaDepositoDownload(
    dispatch: Dispatch,
    conciliacaoContaDepositoId: string,
    stackRequest?: boolean
  ): Promise<any>;
  deleteUploadDoc(dispatch: Dispatch, investidorId: string, documentId: string, stackRequest?: boolean): Promise<any>;
  getConciliacoesPaginated(
    dispatch: Dispatch,
    params?: GETConciliacaoCDFilterParams,
    stackRequest?: boolean): Promise<PaginatedResult<ConciliacaoContaDepositoResponse>>;
  postConfirmarConciliacaoContaDeposito(
    dispatch: Dispatch,
    conciliacaoContaDepositoId: string,
    stackRequest?: boolean
  ): Promise<any>;
  postConfirmarConciliacaoEmLote(
    dispatch: Dispatch,
    ids: string[],
    stackRequest?: boolean
  ): Promise<any>;
  getConciliacoesContasDeposito(
    dispatch: Dispatch,
    date: Moment,
    stackRequest?: boolean
  ): Promise<Array<GETConciliacoesContasDepositoResponse>>;
  getPosicoes(
    dispatch: Dispatch,
    posicoesRequest?: GETInvestidorPosicoesRequest,
    stackRequest?: boolean
  ): Promise<Array<PosicaoResponse>>;
  getBloqueios(
    dispatch: Dispatch,
    stackRequest?: boolean
  ): Promise<Array<BloqueioResponse>>;
  postCertidaoTitularidade(
    dispatch: Dispatch,
    investidorCpfCnpj: string,
    request: CertidaoTitularidadeRequest,
    stackRequest?: boolean
  ): Promise<void>;
  postCertidaoGravame(
    dispatch: Dispatch,
    params: Array<string>,
    stackRequest?: boolean
  ): Promise<void>;
  postCertidaoInadimplencia(
    dispatch: Dispatch,
    params: CertidaoInadimplenciaParams,
    stackRequest?: boolean
  ): Promise<void>;
  getBloqueio(dispatch: Dispatch, bloqueioId: string, stackRequest?: boolean): Promise<BloqueioResponse>;
  postBloqueio(dispatch: Dispatch, bloqueioRequest: BloqueioRequest, stackRequest?: boolean): Promise<BloqueioResponse>;
  postBloqueiosEmLote(
    dispatch: Dispatch,
    bloqueioRequest: AdicionarBloqueioEmLoteRequest,
    stackRequest?: boolean
  ): Promise<Array<ResponseBloqueioEmLote>>;
  putUploadBloqueioDocs(
    dispatch: Dispatch,
    bloqueioId: string,
    bloqueioDocumentType: BloqueioDocumentType,
    files: File[],
    stackRequest?: boolean
  ): Promise<Array<InvestidorDocumentResponse>>;
  postLiberarBloqueio(
    dispatch: Dispatch,
    bloqueioId: string,
    justificativaLiberacao?: string,
    files?: File[],
    stackRequest?: boolean
  ): Promise<BloqueioResponse>;
  getBloqueioDocumentDownloadLink(
    dispatch: Dispatch,
    bloqueioId: string,
    documentId: string,
    stackRequest?: boolean
  ): Promise<string>;
  postExtratos(
    dispatch: Dispatch,
    params: AdicionarExtratoRequest,
    stackRequest?: boolean
  ): Promise<ExtratoResponse>;
  getInvestidorInstrumentos(
    dispatch: Dispatch,
    investidorCpfCnpj: string,
    params: GetInvestidorInstrumentosParams,
    stackRequest?: boolean
  ): Promise<Array<InvestidorInstrumentoFinanceiroResponse>>;
  getInvestidoresEscriturador(
    dispatch: Dispatch,
    params?: GETInvestidoresParams,
    stackRequest?: boolean
  ): Promise<Array<InvestidorResponse>>;
  getFundoInvestidorByInvestidorId(
    dispatch: Dispatch,
    investidorId: string,
    stackRequest?: boolean
  ): Promise<InvestidorFundoResponse>;
  putFundoInvestidor(
    dispatch: Dispatch,
    investidorId: string,
    fundoInvestidorRequest: FundoInvestidorRequest,
    stackRequest?: boolean
  ): Promise<InvestidorFundoResponse>;
}

const investidorApiInitialState: InvestidorApiState = {
  getInvestidor: GETInvestidor,
  getInvestidorByCpfCnpj: GETInvestidorByCpfCnpj,
  postInvestidor: POSTInvestidor,
  postFundoInvestidor: POSTFundoInvestidor,
  putInvestidor: PUTInvestidor,
  getDocumentDownloadUrl: GETInvestidorDocumentDownloadUrl,
  putUploadDoc: PUTUploadDocInvestidor,
  getInvestidores: GETInvestidores,
  postInvestidorPaginated: POSTInvestidorPaginated,
  postBloqueiosPaginated: POSTBloqueiosPaginated,
  deleteInvestidor: DELETEInvestidor,
  postSuspenderInvestidor: POSTSuspenderInvestidor,
  postLiberarSuspensaoInvestidor: POSTLiberarSuspensaoInvestidor,
  getConciliacaoContaDepositoDownload: GETConciliacaoContaDepositoDownload,
  deleteUploadDoc: DELETEUploadDocInvestidor,
  getConciliacoesPaginated: GETConciliacoesPaginated,
  postConfirmarConciliacaoContaDeposito: POSTConfirmarConciliacaoContaDeposito,
  postConfirmarConciliacaoEmLote: POSTConfirmarConciliacaoContaDepositoEmLote,
  getConciliacoesContasDeposito: GETConciliacoesContasDeposito,
  getPosicoes: GETPosicoes,
  getBloqueios: GETBloqueios,
  postCertidaoGravame: POSTCertidaoGravame,
  postCertidaoInadimplencia: POSTCertidaoInadimplencia,
  postCertidaoTitularidade: POSTCertidaoTitularidade,
  getBloqueio: GETBloqueio,
  postBloqueio: POSTBloqueio,
  postBloqueiosEmLote: POSTBloqueiosEmLote,
  putUploadBloqueioDocs: PUTUploadBloqueioDocs,
  postLiberarBloqueio: POSTLiberarBloqueio,
  getBloqueioDocumentDownloadLink: GETBloqueioDocumentDownloadLink,
  postExtratos: POSTExtratos,
  getInvestidorInstrumentos: GETInvestidorInstrumentos,
  getInvestidoresEscriturador: GETInvestidoresEscriturador,
  getFundoInvestidorByInvestidorId: GETFundoInvestidorByInvestidorId,
  putFundoInvestidor: PUTFundoInvestidor,
};

enum InvestidorApiActionType {
  Update = 'investidorApi/UPDATE',
  Reset = 'investidorApi/RESET',
}

export const updateInvestidorApi = (state: InvestidorApiState) => {
  return typedAction(InvestidorApiActionType.Update, state);
};

export const resetInvestidorApi = () => {
  return typedAction(InvestidorApiActionType.Reset);
};

type InvestidorApiAction = ReturnType<typeof updateInvestidorApi | typeof resetInvestidorApi>;

export function investidorApiReducer(
  state: InvestidorApiState = investidorApiInitialState,
  action: InvestidorApiAction
): InvestidorApiState {
  switch (action.type) {
    case InvestidorApiActionType.Update:
      return { ...action.payload };
    case InvestidorApiActionType.Reset:
      return { ...investidorApiInitialState };
    default:
      return state;
  }
}
